import FuseUtils from '@fuse/utils';
import { amber } from '@material-ui/core/colors';
import Divider from '@material-ui/core/Divider';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import * as UserActions from 'app/auth/store/actions';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Logo from 'app/fuse-layouts/shared-components/Logo';
import ProjectSelector from 'app/fuse-layouts/shared-components/ProjectSelector';
import Hidden from '@material-ui/core/Hidden';
import * as Actions from 'app/store/actions';
import { useLocation } from 'react-router';


import { AiOutlineInfoCircle, AiTwotonePropertySafety } from "react-icons/ai";
import { BiCctv } from "react-icons/bi";
import { BsFillCameraVideoFill } from "react-icons/bs";
import { CgCalendar } from "react-icons/cg";
// import { MdFormatBold, MdRouter, Md3DRotation } from "react-icons/md";
// import { RiGoogleFill } from "react-icons/ri";
// import { TiInfoOutline } from "react-icons/ti";
import clsx from 'clsx';


const useStyles = makeStyles((theme) => ({
	root: {
		'&.horizontal': {},
		'&.vertical': {
			flexDirection: 'column'
		}
	},
	item: {
		textDecoration: 'none!important',
		color: 'inherit'
	},
	addIcon: {
		color: amber[600]
	},
	boxProjejectSelector: {
		display: 'flex',
		alignItems: 'center',
		width: '40vh',
		[theme.breakpoints.down('md')]: {
			width: '37vh',
		},
		[theme.breakpoints.down('sm')]: {
			width: '28vh',
		},
		[theme.breakpoints.down('xs')]: {
			width: '22vh',
		},
	},
	styleCompanyName: {
		display: 'flex',
		width: '50%',
		justifyContent: 'center',
		alignItems: 'center',
		whiteSpace: 'nowrap',
		fontSize: '2rem',
		fontWeight: 'bold',
		color: theme.palette.scaiPro.primary,
		//paddingLeft:'70px',
	},
	companyTxt: {
		color: theme.palette.scaiPro.textSecondary,
		marginTop: '5px',
		fontSize: '1.2rem',
	},
	projectCodeArea: {
		backgroundColor: 'white',
		color: '#6884c3',
		border: '1px solid rgba(104, 132, 195, 0.5)',
		borderRadius: '5px',
		marginRight: '10px',
		padding: '5px 10px',
		fontSize: '1.4rem',
		height: '36.5px',
		width: '40vh',
		textOverflow: 'ellipsis',
		alignItems: 'center',
		fontWeight: 'bold'
	},
	projectCodeAreaNone: {
		display: 'none',
	}
}));

function FuseShortcuts(props) {
	const dispatch = useDispatch();
	const shortcuts = useSelector(({ auth }) => auth.user.data.shortcuts);
	const navigationData = useSelector(({ fuse }) => fuse.navigation);
	const location = useLocation();

	const classes = useStyles(props);
	const searchInputRef = useRef(null);
	const [addMenu, setAddMenu] = useState(null);
	const [searchText, setSearchText] = useState('');
	const [searchResults, setSearchResults] = useState(null);
	const [navigation, setNavigation] = useState(null);
	const shortcutItems = shortcuts ? shortcuts.map(id => FuseUtils.findById(navigationData, id)) : [];
	const handleCompanyProject = useSelector(({ multipleCompanies }) => multipleCompanies.multipleCompanies.handleDetails);
	const getSideMenuItems = useSelector(({ multipleCompanies }) => multipleCompanies.multipleCompanies.getSideMenuItems);
	const projectSelectedValues = JSON.parse(localStorage.getItem('persistProjectSelected'));
	const currentProjectName = projectSelectedValues?.project_type?.name;
	//const isAdmin = useSelector((fuse) => fuse.fuse.navigation[3].children[0].children); 
	//const flagClickCompanies = useSelector(({ multipleCompaniesApp }) => multipleCompaniesApp.multipleCompanies.flagClickCompanies);
	//const chat = useSelector(({ chatPanel }) => chatPanel.chat);
	const [dynamicHeader, setDynamicHeader] = useState(null);
	const [companyName, setCompanyName] = useState(null);
	const [projectCode, setProjectCode] = useState(null);

	//SideMenu Items
	const [companies, setCompanies] = useState(false);
	const [members, setMembers] = useState(false);
	const [projects, setProjects] = useState(false);
	const [initialization, setInitialization] = useState(false);

	const [dashboard, setDashboard] = useState(false);
	const [connect, setConnect] = useState(false);
	const [liveStream, setLiveStream] = useState(false);
	const [downloadStream, setDownloadStream] = useState(false);
	const [contact, setContact] = useState(false);
	const [ctm, setCTM] = useState(false);
	const [cctvMap, setCCTVMAP] = useState(false);
	const [cctv, setCCTV] = useState(false);
	const [safety, setSafety] = useState(false);

	//::CHECKING IF HAS CTM PROJECTS
	let current = localStorage.getItem('current_user')
	const currentUser = JSON.parse(current);
	const currentMemberType = currentUser.membertype.id;
	const projectSelectAPI = currentUser?.userProjectData;
	const typeOfProjects = projectSelectAPI?.map(list => list?.project_type?.uuid);
	const onlyCTM = typeOfProjects?.length !== 0 && typeOfProjects?.find(isCTM) || currentMemberType == 6;

	function isCTM(ctm) {
		return ctm === 'c6a22e66-db0d-4c59-9c27-7dcb9888150e'; //CTM UUID
	}

	// useEffect(()=>{
	// 	console.log('CURRENT PROJECTS :::: ', projectSelectAPI?.length === 0)
	// })

	// useEffect(()=>{
	// 	dispatch(Actions.getSideMenuItems());
	// 	// eslint-disable-next-line react-hooks/exhaustive-deps
	// },[]);

	useEffect(() => {
		//::Cleaning Pagination from Table
		localStorage.removeItem('pageData');
	});

	useEffect(() => {
		const arrayItems = getSideMenuItems?.data?.map(list => list.name);
		// console.log('GET SIDE MENU ITEMS IN FUSE SHORTCUTS: ', getSideMenuItems);
		// console.log('GET SIDE MENU ITEMS IN FUSE SHORTCUTS CURRENT PROJECT: ', currentProjectName);
		console.log("currentProjectName : " + currentProjectName);
		console.log("onlyCTM : " + onlyCTM);
		if (getSideMenuItems) {
			console.log('getSideMenuItems.data : ', getSideMenuItems.data)
			if (getSideMenuItems.data) {
				arrayItems.find(el => el === 'Companies') ? setCompanies(true) : setCompanies(false);
				arrayItems.find(el => el === 'Members') ? setMembers(true) : setMembers(false);
				arrayItems.find(el => el === 'Projects') ? setProjects(true) : setProjects(false);
				arrayItems.find(el => el === 'Initialization') ? setInitialization(true) : setInitialization(false);

				arrayItems.find(el => el === 'Connect') ? setConnect(true) : setConnect(false);

				arrayItems.find(el => el === 'Dashboard') ? setDashboard(true) : setDashboard(false);
				arrayItems.find(el => el === 'Live Stream') ? setLiveStream(true) : setLiveStream(false);
				arrayItems.find(el => el === 'Download Stream') ? setDownloadStream(true) : setDownloadStream(false);
				arrayItems.find(el => el === 'Contact') ? setContact(true) : setContact(false);
				arrayItems.find(el => el === 'CCTV Map') ? setCCTVMAP(true) : setCCTVMAP(false);
				arrayItems.find(el => el === 'CCTV') ? setCCTV(true) : setCCTV(false);
				arrayItems.find(el => el === 'Safety') ? setSafety(true) : setSafety(false);

				//::FOR CTM
				onlyCTM ? setCTM(true) : setCTM(false);
			}
		} else {
			setDashboard(false);
			setLiveStream(false);
			setDownloadStream(false);
			setContact(false);
			setCCTVMAP(false);
			setCCTV(false);
			setSafety(false);
			setCTM(false);
		}
	}, [getSideMenuItems, currentProjectName, onlyCTM]);

	const newNavigation = [
		// {
		// 	id: 'Documentation',
		// 	title: 'Documentation',
		// 	type: 'group',
		// 	icon: 'star',
		// 	children: [
		// 		{
		// 			id: 'getting-started-doc',
		// 			title: 'Getting Started',
		// 			type: 'collapse',
		// 			icon: 'import_contacts',
		// 			children: [
		// 				{
		// 					id: 'installation-doc',
		// 					title: 'Installation',
		// 					type: 'item',
		// 					url: '/documentation/getting-started/installation'
		// 				},
		// 				{
		// 					id: 'installation-launching-project',
		// 					title: 'Launching Project',
		// 					type: 'item',
		// 					url: '/documentation/getting-started/launching'
		// 				}
		// 			]
		// 		},
		// 		{
		// 			id: 'working-with-fuse-react-doc',
		// 			title: 'Working with React',
		// 			type: 'collapse',
		// 			icon: 'import_contacts',
		// 		},
		// 	]
		// },
		// {
		// 	type: members ? 'divider' : null,
		// 	id: 'divider-1'
		// },
		// {
		// 	id: 'switch',
		// 	title: 'switch',
		// 	translate: 'switch',
		// 	type: 'group',
		// 	icon: 'apps',
		// 	children: [
		// 		{
		// 			id: 'switch-to-admmin',
		// 			title: 'Homepage',
		// 			translate: 'SWITCH_TO_USER',
		// 			type: 'item',
		// 			icon: 'compare_arrows',
		// 			url: '/switch_user'
		// 		},
		// 	],
		// },
		{
			id: 'isAdmin',
			title: 'isAdmin',
			translate: 'ADMIN SECTION',
			type: members ? 'group' : null,
			icon: 'apps',
			exact: true,
			children: [
				{
					id: 'multipleCompanies',
					title: 'Multiple Companies',
					translate: 'MULTIPLE_COMPANIES',
					type: companies ? 'item' : null,
					icon: 'work_outline',
					url: '/multipleCompanies',
					exact: true,
				},

				{
					id: 'addmember',
					title: 'Add member',
					translate: 'ADDMEMBER',
					type: members ? 'item' : null,
					icon: 'person_add',
					url: '/members',
					exact: true
				},
				{
					id: 'projects',
					title: 'Projects',
					translate: 'ADDPROJECT',
					type: projects ? 'item' : null,
					icon: 'tv',
					url: '/projects',
					exact: true,
				},
				// {
				// 	id: 'mapping',
				// 	title: 'Mapping',
				// 	translate: 'MAPPING',
				// 	type: 'item',
				// 	icon: <FaNetworkWired />,
				// 	url: '/mapping'
				// },
				{
					id: 'initialization',
					title: 'Initialization',
					translate: 'INITIALIZATION',
					type: initialization ? 'item' : null,
					icon: 'domain',
					url: '/initialization/0'
				},
			]
		},
		{
			type: 'divider',
			id: 'divider-2'
		},
		// IS USER CATEGORY
		{
			id: 'is-user',
			title: 'USER SECTION',
			type: 'group',
			icon: 'web',
			children: [
				{
					id: 'dashboard-user-no-group',
					title: 'Home',
					translate: 'HOME',
					type: 'item',
					icon: 'home',
					url: '/dashboard/map',
					exact: true
				},
				// {
				// 	id: 'ctm',
				// 	title: 'Ctm',
				// 	translate: 'CTM',
				// 	type: ctm ? 'item' : null,
				// 	icon: <AiOutlineInfoCircle />,
				// 	url: '/ctm'
				// },
				// {
				// 	id: 'cctv-map',
				// 	title: 'CCTV Map',
				// 	translate: 'CCTV_MAP',
				// 	type: cctvMap ? 'item' : null,
				// 	icon: <BiCctv/>,
				// 	url: '/project_map/<uuid>'
				// },
				// {
				// 	id: 'cctv',
				// 	title: 'CCTV',
				// 	translate: 'CCTV',
				// 	type: cctv ? 'link' : null,
				// 	icon: <BsFillCameraVideoFill />,
				// 	url: 'https://safie.link'
				// },

				{
					id: 'safety',
					title: 'Safety',
					translate: 'SAFETY',
					type: safety ? 'link' : null,
					icon: <AiTwotonePropertySafety />,
					url: 'https://153.149.159.17/andohazama/TP/TP001_Login.php'
				},
				// {
				// 	id: 'buildee',
				// 	title: 'Buildee',
				// 	translate: 'BUILDEE',
				// 	type: 'link',
				// 	icon: <MdFormatBold />,
				// 	url: 'https://buildee.jp'
				// },
				// {
				// 	id: 'greensite',
				// 	title: 'Green Site',
				// 	translate: 'GREEN_SITE',
				// 	type: 'link',
				// 	icon: <RiGoogleFill />,
				// 	url: 'https://portal.kensetsu-site.com/login'
				// },
				// {
				// 	id: 'riskprediction',
				// 	title: 'Risk prediction',
				// 	translate: 'RISK_PREDICTION',
				// 	type: 'link',
				// 	icon: <TiInfoOutline />,
				// 	url: 'https://www.lbw.co.jp/kkymail/giken.html'
				// },
				// {
				// 	id: 'iot2d',
				// 	title: 'IOT (2D)',
				// 	translate: 'IOT2D',
				// 	type: 'link',
				// 	icon: <MdRouter />,
				// 	url: 'http://104.42.210.251/adhzm/index.asp'
				// },
				// {
				// 	id: 'iot3d',
				// 	title: 'IOT (3D)',
				// 	translate: 'IOT3D',
				// 	type: 'link',
				// 	icon: <Md3DRotation />,
				// 	url: 'http://powercubeorg.ddns.net/sensor_view/?site_id=1'
				// },
				// {
				// 	id: 'trello',
				// 	title: 'TRELLO',
				// 	type: 'link',
				// 	icon: <FaTrello />,
				// 	url: 'https://trello.com/b/IrkiLyod/react-work'
				// },
			]
		},

		/*****CTM PAGE*****/
		{
			type: 'divider',
			id: 'divider-3'
		},
		{
			id: 'ctm',
			title: 'Ctm',
			translate: 'CTM',
			type: ctm ? 'item' : null,
			icon: <AiOutlineInfoCircle />,
			url: '/ctm',
			end: true,
		},
	];

	useEffect(() => {
		console.log('REFRESHED NEW NAVIGATION ~!!!!!!', newNavigation);
		//dispatch(Actions.setNavigation(''));
		setTimeout(() => {
			dispatch(Actions.setNavigation(newNavigation));
		}, 0);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		companies,
		members,
		projects,
		initialization,
		dashboard,
		connect,
		contact,
		liveStream,
		downloadStream,
		cctv,
		cctvMap,
		safety,
		ctm,
	]);

	//::Persist Data
	useEffect(() => {
		//console.log('PERSIST EVERETHING HERE ==', handleCompanyProject);
		handleCompanyProject && localStorage.setItem('persistCompanyData', JSON.stringify(handleCompanyProject));
		handleCompanyProject && handleCompanyProject.name && localStorage.setItem('persistCompanyName', handleCompanyProject.name);
		handleCompanyProject && handleCompanyProject.domain && localStorage.setItem('persistDomain', handleCompanyProject.domain);
		handleCompanyProject && handleCompanyProject.companyID && localStorage.setItem('persistCompanyID', handleCompanyProject.companyID);
	}, [handleCompanyProject]);

	useEffect(() => {
		if (handleCompanyProject && handleCompanyProject.companyID) {
			dispatch(Actions.members_getProjectBranch(handleCompanyProject.companyID));
			dispatch(Actions.members_getProjects(handleCompanyProject.companyID));


			//::Test New API
			dispatch(Actions.projectSelectAPI(handleCompanyProject.companyID));
		} else {
			dispatch(Actions.members_getProjectBranch(JSON.parse(localStorage.getItem('persistCompanyID'))));
			dispatch(Actions.members_getProjects(JSON.parse(localStorage.getItem('persistCompanyID'))));


			//::Test New API
			dispatch(Actions.projectSelectAPI(JSON.parse(localStorage.getItem('persistCompanyID'))));
		}
	}, [dispatch, handleCompanyProject]);


	//::Show and hide Select Project dropdown 
	useEffect(() => {
		//console.log('COMPANY NAME', handleCompanyProject.name);
		//console.log(' COMPANY NAME FROM STORAGE ===>', storageCompanyName)
		const storageCompanyName = localStorage.getItem('persistCompanyName');
		if (
			location.pathname === '/dashboard/admin' ||
			location.pathname === '/members' ||
			location.pathname.startsWith('/projects') ||
			location.pathname === '/mapping' ||
			location.pathname.startsWith('/initialization') ||
			location.pathname === '/devices'
		) {
			//ADMIN PART
			setDynamicHeader('');
			setCompanyName('');
			setProjectCode('');

			handleCompanyProject.name ?
				setDynamicHeader(
					<div className={classes.styleCompanyName}>
						{handleCompanyProject.name}
					</div>)
				:
				setDynamicHeader(
					<div className={classes.styleCompanyName}>
						{storageCompanyName}
					</div>
				);
		} else if (location.pathname.startsWith('/multipleCompanies')) {
			//ADMIN PART
			setDynamicHeader('');
			setCompanyName('');
			setProjectCode('');
		} else {
			//USER PART
			if (handleCompanyProject.name) {
				setDynamicHeader(
					<div className={classes.boxProjejectSelector}>
						<ProjectSelector />
					</div>
				)

				setCompanyName(
					<>
						<div className={classes.companyTxt}>Company</div>
						<div>{handleCompanyProject.name}</div>
					</>
				);
				projectSelectedValues == null ?
					setProjectCode('')
					:
					setProjectCode(
						<div className="flex flex-1 mx-6">
							<div className={clsx('flex flex-col handleComitems-start justify-center', classes.projectCodeArea)}>
								工事コード　{projectSelectedValues.projectCode}
							</div>
						</div>
					);
			} else {
				setDynamicHeader(
					<div className={classes.boxProjejectSelector}>
						<ProjectSelector />
					</div>
				);

				setCompanyName(
					<>
						<div className={classes.companyTxt}>Company</div>
						<div>{storageCompanyName}</div>
					</>
				);

				projectSelectedValues == null ?
					setProjectCode('')
					:
					setProjectCode(
						<div className="flex flex-1 mx-6">
							<div className={clsx('flex flex-col handleComitems-start justify-center', classes.projectCodeArea)}>
								工事コード　{projectSelectedValues.projectCode}
							</div>
						</div>
				);

			}
			
		}

	}, [handleCompanyProject, location, classes.boxProjejectSelector, classes.companyTxt, classes.styleCompanyName, projectSelectedValues?.projectCode])

	useEffect(() => {
		function flattenNavigation() {
			setNavigation(FuseUtils.getFlatNavigation(navigationData));
		}

		flattenNavigation();
	}, [props.location, navigationData]);

	function addMenuClose() {
		setAddMenu(null);
	}

	function search(ev) {
		const newSearchText = ev.target.value;

		setSearchText(newSearchText);

		if (newSearchText.length !== 0 && navigation) {
			setSearchResults(navigation.filter(item => item.title.toLowerCase().includes(newSearchText.toLowerCase())));
			return;
		}
		setSearchResults(null);
	}

	function toggleInShortcuts(id) {
		let newShortcuts = [...shortcuts];
		newShortcuts = newShortcuts.includes(id) ? newShortcuts.filter(_id => id !== _id) : [...newShortcuts, id];
		dispatch(UserActions.updateUserShortcuts(newShortcuts));
	}

	function ShortcutMenuItem({ item, onToggle }) {
		return (
			<Link to={item.url} className={classes.item} role="button">
				<MenuItem key={item.id}>
					<ListItemIcon className="min-w-40">
						{item.icon ? (
							<Icon>{item.icon}</Icon>
						) : (
							<span className="text-20 font-bold uppercase text-center">{item.title[0]}</span>
						)}
					</ListItemIcon>
					<ListItemText primary={item.title} />
					{/* <IconButton
						onClick={ev => {
							ev.preventDefault();
							ev.stopPropagation();
							onToggle(item.id);
						}}
					>
						<Icon color="action">{shortcuts.includes(item.id) ? 'star' : 'star_border'}</Icon>
					</IconButton> */}
				</MenuItem>
			</Link>
		);
	}

	return (
		<div
			className={clsx(
				classes.root,
				props.variant,
				'flex flex-1',
				props.variant === 'vertical' && 'flex-grow-0 flex-shrink',
				props.className
			)}
		>
			<Hidden mdDown>
				<div className="flex flex-1 mx-2">
					<Logo style={`width:100px;height:auto`} />
				</div>
			</Hidden>
			{/* <Hidden xsDown> */}
			{console.log("projectSelectedValues : " + projectSelectedValues)}
			{console.log("handleCompanyProject.name : " + handleCompanyProject.name)}
			{projectCode}
			{/* </Hidden> */}

			<div className="flex flex-1 mx-6">
			{console.log("projectSelectedValues : " + projectSelectedValues)}
			{console.log("handleCompanyProject.name : " + handleCompanyProject.name)}
				{/* <div className={`${handleCompanyProject.name === undefined ? classes.boxProjejectSelector : classes.styleCompanyName}`}> */}
					{dynamicHeader}
				{/* </div> */}
			</div>
			<Hidden xsDown>
				<div className={clsx('flex flex-col items-start justify-center', classes.boxCompanyUserSection)}>
					{companyName}
				</div>
			</Hidden>

			{/* 	<FuseAnimateGroup
				enter={{
					animation: 'transition.expandIn'
				}}
				className={clsx('flex flex-1', props.variant === 'vertical' && 'flex-col')}
			>
				{shortcutItems.map(
					item =>
						item && (
							<Link to={item.url} key={item.id} className={classes.item} role="button">
								<Tooltip
									title={item.title}
									placement={props.variant === 'horizontal' ? 'bottom' : 'left'}
								>
									<IconButton className="w-40 h-40 p-0">
										{item.icon ? (
											<Icon>{item.icon}</Icon>
										) : (
											<span className="text-20 font-bold uppercase">{item.title[0]}</span>
										)}
									</IconButton>
								</Tooltip>
							</Link>
						)
				)}

				<Tooltip
					title="Click to add/remove shortcut"
					placement={props.variant === 'horizontal' ? 'bottom' : 'left'}
				>
					<IconButton
						className="w-40 h-40 p-0"
						aria-owns={addMenu ? 'add-menu' : null}
						aria-haspopup="true"
						onClick={addMenuClick}
					>
						<Icon className={classes.addIcon}>star</Icon>
					</IconButton>
				</Tooltip>

			</FuseAnimateGroup>
		*/}
			<Menu
				id="add-menu"
				anchorEl={addMenu}
				open={Boolean(addMenu)}
				onClose={addMenuClose}
				classes={{
					paper: 'mt-48'
				}}
			/*onEntered={() => {
				searchInputRef.current.focus();
			}}
			onExited={() => {
				setSearchText('');
			}}*/
			>
				<div className="p-16 pt-8">
					<Input
						inputRef={searchInputRef}
						value={searchText}
						onChange={search}
						placeholder="Search for an app or page"
						className=""
						fullWidth
						inputProps={{
							'aria-label': 'Search'
						}}
					/>
				</div>

				<Divider />

				{searchText.length !== 0 &&
					searchResults &&
					searchResults.map(item => (
						<ShortcutMenuItem key={item.id} item={item} onToggle={() => toggleInShortcuts(item.id)} />
					))}

				{searchText.length !== 0 && searchResults.length === 0 && (
					<Typography color="textSecondary" className="p-16 pb-8">
						No results..
					</Typography>
				)}

				{searchText.length === 0 &&
					shortcutItems.map(
						item =>
							item && (
								<ShortcutMenuItem
									key={item.id}
									item={item}
									onToggle={() => toggleInShortcuts(item.id)}
								/>
							)
					)}
			</Menu>
		</div>
	);
}

FuseShortcuts.propTypes = {};
FuseShortcuts.defaultProps = {
	variant: 'horizontal'
};

export default React.memo(FuseShortcuts);
//export default AddProject;
//export default React.memo(withReducer('fuseShortcutsAppApp', reducer)(FuseShortcuts));